export type autozoneRequestStatus =
  | "default"
  | "loading"
  | "success"
  | "error"
  | "retry";
export enum AUTOZONE_REQUEST_STATUS {
  DEFAULT = "default",
  LOADING = "loading",
  SUCCESS = "success",
  ERROR = "error",
  RETRY = "retry",
}

export type AUTOZONE_VARIABILITY_LEVEL = "LOW" | "MEDIUM" | "HIGH";

export type AutozoneOpacity = number;

export enum AutozoneColorPalette {
  NDVI = "NDVI",
  DEFAULT = "DEFAULT",
  ACCESSIBILITY = "ACCESSIBILITY",
}
export interface AutozoneIntervalsInterface {
  response_version: string;
  model: {
    name: string;
    version: string;
    submodel: {
      name: string;
      version: string;
    };
  };
  metadata: {
    packages: {
      cropwise_data_science: string;
      productivity_zones: string;
      variability_index: string;
    };
    result_time: number;
  };
  results: Array<{
    predictions: Array<{
      country: string;
      seasons: Array<{
        end_date: string;
        season: string;
        images: Array<{
          field_id: string;
          sub_products: string[];
          acquired_at: string;
          last_processed_at: string;
          cloud_coverage: number;
          id: string;
          source: string;
          ndvi_mean: number;
          ndvi_min: number;
          ndvi_std: number;
          data_coverage: number;
          ndvi_max: number;
        }>;
        peak_date: string;
        start_date: string;
      }>;
    }>;
    region: string;
    config: {
      region: {
        exclude_seasons: null | string;
      };
      country: {
        min_days_in_intervals: number;
        min_days_between_intervals: number;
        merge_overlap_intervals: boolean;
      };
      custom: {
        exclude_seasons: null | string;
      };
    };
  }>;
  id: string;
}
export const emptyAutozoneIntervalsObject: AutozoneIntervalsInterface = {
  response_version: "",
  model: {
    name: "",
    version: "",
    submodel: {
      name: "",
      version: "",
    },
  },
  metadata: {
    packages: {
      cropwise_data_science: "",
      productivity_zones: "",
      variability_index: "",
    },
    result_time: 0,
  },
  results: [
    {
      predictions: [
        {
          country: "",
          seasons: [
            {
              end_date: "",
              season: "",
              images: [
                {
                  field_id: "",
                  sub_products: [],
                  acquired_at: "",
                  last_processed_at: "",
                  cloud_coverage: 0,
                  id: "",
                  source: "",
                  ndvi_mean: 0,
                  ndvi_min: 0,
                  ndvi_std: 0,
                  data_coverage: 0,
                  ndvi_max: 0,
                },
              ],
              peak_date: "",
              start_date: "",
            },
          ],
        },
      ],
      region: "",
      config: {
        region: {
          exclude_seasons: null,
        },
        country: {
          min_days_in_intervals: 0,
          min_days_between_intervals: 0,
          merge_overlap_intervals: false,
        },
        custom: {
          exclude_seasons: null,
        },
      },
    },
  ],
  id: "",
};

export interface ProductivityZonesInterface {
  response_version: string;
  model: {
    name: string;
    version: string;
    submodel: {
      name: string;
      version: string;
    };
  };
  metadata: {
    packages: {
      cropwise_data_science: string;
      productivity_zones: string;
      variability_index: string;
    };
    result_time: number;
  };
  results: Array<{
    id: string;
    predictions: Array<{
      productivity_zones: {
        features: Array<{
          geometry: {
            type: string;
            coordinates: number[][][];
          };
          properties: {
            group: number;
            percentiles: {
              p25: number;
              p50: number;
              p10: number;
              p90: number;
              p75: number;
            };
            productivity_adjustment_factor?: number;
          };
        }>;
      };
    }>;
  }>;
}
export const emptyProductivityZonesObject: ProductivityZonesInterface = {
  response_version: "",
  model: {
    name: "",
    version: "",
    submodel: {
      name: "",
      version: "",
    },
  },
  metadata: {
    packages: {
      cropwise_data_science: "",
      productivity_zones: "",
      variability_index: "",
    },
    result_time: 0,
  },
  results: [
    {
      id: "",
      predictions: [
        {
          productivity_zones: {
            features: [
              {
                geometry: {
                  type: "",
                  coordinates: [],
                },
                properties: {
                  group: 0,
                  percentiles: {
                    p25: 0.11,
                    p50: 0.22,
                    p10: 0.33,
                    p90: 0.44,
                    p75: 0.55,
                  },
                },
              },
            ],
          },
        },
      ],
    },
  ],
};

export interface VariabilityIndexDataInterface {
  response_version: string;
  model: {
    name: string;
    version: string;
    submodel: {
      name: string;
      version: string;
    };
  };
  metadata: {
    packages: {
      cropwise_data_science: string;
      productivity_zones: string;
      variability_index: string;
    };
    result_time: number;
  };
  results: Array<{
    id: string;
    predictions: Array<{
      variability: number;
      consistency: number;
      vxc: number;
      seasons: Array<{
        season: string;
        start_date: string;
        end_date: string;
        peak_date: string;
      }>;
    }>;
  }>;
}

export const variabilityIndexDataEmptyState: VariabilityIndexDataInterface = {
  response_version: "",
  model: {
    name: "",
    version: "",
    submodel: {
      name: "",
      version: "",
    },
  },
  metadata: {
    packages: {
      cropwise_data_science: "",
      productivity_zones: "",
      variability_index: "",
    },
    result_time: 0,
  },
  results: [
    {
      id: "",
      predictions: [
        {
          variability: 0,
          consistency: 0,
          vxc: 0,
          seasons: [
            {
              season: "",
              start_date: "",
              end_date: "",
              peak_date: "",
            },
          ],
        },
      ],
    },
  ],
};
